import React, { useState } from "react";
import CustomTab from "../../components/common/CustomTab"; // Assuming this is your custom tab component
import { UserGroupIcon } from "@heroicons/react/20/solid"; // Icon for the tab
import AllLeads from "./AllLeads"; // Import AllLeads component
import PageHeader from "../../components/layout/LayoutWrapper/PageHeader";
import { useLocation } from "react-router-dom";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import { BsFillCloudPlusFill } from "react-icons/bs";
import DownloadIssuanceExcelModal from "./DownloadIssuanceExcelModal";
const LeadsTab = () => {
  const location = useLocation();
  const totalLeads = location.state?.totalLeads || 0;
  const [isUploadModalOpen, setUploadModalOpen] = useState(false);

  const handleUploadClick = () => {
    setUploadModalOpen(true);
  };
  return (
    <div className="flex flex-col flex-1 mt-0">
      <div className="flex flex-col mb-4">
        <div className="flex items-center justify-between mb-4">
          <PageHeader
            title={
              <span className="flex items-center gap-2">
                Leads
                <span className="text-lg font-semibold text-gray-700">
                  ({totalLeads})
                </span>
              </span>
            }
            showBack
            size="md"
          />
          <CustomButton
            className="flex items-center justify-center gap-2"
            style={{
              border: "1px solid #0184FF",
              background: "#EAF4FF",
              color: "#0184FF",
            }}
            startIcon={
              <BsFillCloudPlusFill
                style={{ color: "#0184FF", fontSize: "18px" }}
              />
            }
            label="Upload Excel"
            onClick={handleUploadClick}
          />
        </div>
        <DownloadIssuanceExcelModal open={isUploadModalOpen} setOpen={setUploadModalOpen} />
      </div>

      <CustomTab
        tabIndex={0}
        tabList={[
          {
            title: "Insurance",
            component: <AllLeads />,
          },
          {
            title: "Mutual Funds",
            component: <div>Mutual Funds Content</div>,
          },
          {
            title: "Loans",
            component: <div>Loans Content</div>,
          },
          {
            title: "Investments",
            component: <div>Investments Content</div>,
          },
        ]}
      />
    </div>
  );
};

export default LeadsTab;
